import type { CountryEcobalyse } from "@tfg/db"
import { t } from "i18next"

import { FabricProcess } from "@tfg/types/endpoints/enum"

export const SUPPLIER_CARD_HEIGHT = 260

export const ITEM_CARD_HEIGHT = 260

export const FABRIC_PROCESS_TRANSLATIONS: {
  [key in FabricProcess]: string
} = {
  "knitting-mix": t("fabricProcess.knitting-mix"),
  "knitting-fully-fashioned": t("fabricProcess.knitting-fully-fashioned"),
  "knitting-integral": t("fabricProcess.knitting-integral"),
  "knitting-circular": t("fabricProcess.knitting-circular"),
  "knitting-straight": t("fabricProcess.knitting-straight"),
  weaving: t("fabricProcess.weaving"),
}

export const COUNTRIES_ECOBALYSE: {
  [key in CountryEcobalyse]: string
} = {
  BD: t("countriesEcobalyse.BD"),
  CN: t("countriesEcobalyse.CN"),
  FR: t("countriesEcobalyse.FR"),
  IN: t("countriesEcobalyse.IN"),
  KH: t("countriesEcobalyse.KH"),
  MM: t("countriesEcobalyse.MM"),
  MA: t("countriesEcobalyse.MA"),
  PK: t("countriesEcobalyse.PK"),
  TN: t("countriesEcobalyse.TN"),
  TR: t("countriesEcobalyse.TR"),
  VN: t("countriesEcobalyse.VN"),
  REO: t("countriesEcobalyse.REO"),
  RLA: t("countriesEcobalyse.RLA"),
  RNA: t("countriesEcobalyse.RNA"),
  ROC: t("countriesEcobalyse.ROC"),
  REE: t("countriesEcobalyse.REE"),
  RAF: t("countriesEcobalyse.RAF"),
  RAS: t("countriesEcobalyse.RAS"),
  RME: t("countriesEcobalyse.RME"),
}
